import React, { useEffect, useState } from "react";
import { Form, Select, Input,Checkbox } from "antd";
import { useSearchParams } from "react-router-dom";
import LoadableButton from "../../components/buttons/LoadableButton.jsx";
import { GetAllCountryApi } from '../../api/request/common.js';
import { RegisterApi } from '../../api/request/users.js';
import toast from "react-hot-toast";
import { Link } from 'react-router-dom';
import { useResponsive } from "../../hooks/useResponsive.js";

function Register() {
  const { isMobile } = useResponsive();
  const [form] = Form.useForm();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [initialValues, setInitialValues] = useState({ firstName: "", lastName: "", email: "", phoneNo: "", countryId: null, referralCode: (searchParams?.get('ref'))?.trim() });

  const getContriens = async () => {
    try {
      const { data } = await GetAllCountryApi();
      if (data?.success) {
        setCountries(data?.data?.map((item) => ({ ...item, value: item?.id, label: item?.countryName })));
      }
    } catch (error) { }
  }

  useEffect(() => {
    getContriens();
  }, []);

  const handleSubmit = async (values) => {
    try {
      setIsLoading(true);
      const { data } = await RegisterApi(values);
      if (data?.success) {
        toast.success(data?.message);
        form.resetFields();
        setSearchParams('tab=login');
      }
      setIsLoading(false);
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
      setIsLoading(false);
    }
  }
  const filterOption = (input, option) => {
    return (option?.label ?? '').toLowerCase().includes(input.toLowerCase());
  }

  const isAllowKey = (e) => {
    const value = e.target.value;
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab", "End", "Home", "Enter"];
    if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
    if (/[0-9]/.test(e.key) && value.length >= 10) {
      e.preventDefault();
    }
  }

  return (
    <div className="auth-page">
      {isMobile && <div className="my-5 mt-10">
        <p className="text-xl font-bold mb-2 text-dark-200">Register</p>
        <p className="text-gray-500">Welcome, Please register to access your Account</p>
      </div>}
      <Form autoComplete="off" form={form} initialValues={initialValues} onFinish={handleSubmit}>
        <div className="grid sm:grid-cols-2 grid-cols-1 gap-3 text-sm font-normal">
          <div className="py-1">
            {!isMobile && <p className="text-[#585F70] font-semibold mb-[2px]">First Name</p>}
            <Form.Item name='firstName' rules={[{ required: true, message: 'Please enter first name.' }]}>
              <Input placeholder="First name" className="border border-slate-200 md:border-[#d9d9d9] rounded-[14px] md:rounded-lg  w-full ps-3 md:ps-2 py-3 md:py-2" />
            </Form.Item>
          </div>
          <div className="py-1">
            {!isMobile && <p className="text-[#585F70] font-semibold mb-[2px]">Last Name</p>}
            <Form.Item name='lastName' rules={[{ required: true, message: 'Please enter last name.' }]}>
              <Input placeholder="Last name" className="border border-slate-200 md:border-[#d9d9d9] rounded-[14px] md:rounded-lg w-full ps-3 md:ps-2 py-3 md:py-2" />
            </Form.Item>
          </div>
          <div className="py-1 sm:col-span-2">
            {!isMobile && <p className="text-[#585F70] font-semibold mb-[2px]">Email</p>}
            <Form.Item name='email' rules={[{ required: true, type: 'email', message: 'Please enter valid email.' }]}>
              <Input placeholder="Email-id" className="border border-slate-200 md:border-[#d9d9d9] rounded-[14px] md:rounded-lg w-full ps-3 md:ps-2 py-3 md:py-2" />
            </Form.Item>
          </div>
          <div className="py-1">
            {!isMobile && <p className="text-[#585F70] font-semibold mb-[2px]">Phone No.</p>}
            <Form.Item name='phoneNo' rules={[{ required: true, message: 'Please enter phone number.' }]}>
              <Input maxLength={10} placeholder="Phone No." className="border border-slate-200 md:border-[#d9d9d9] rounded-[14px] md:rounded-lg w-full ps-3 md:ps-2 py-3 md:py-2" onKeyDown={(e) => isAllowKey(e)} />
            </Form.Item>
          </div>
          <div className="py-1">
            {!isMobile && <p className="text-[#585F70] font-semibold mb-[2px]">Select Country</p>}
            <Form.Item name="countryId" rules={[{ required: true, message: 'Please select a country.' }]}>
              <Select showSearch filterOption={filterOption} options={countries} placeholder='Select country' className="h-full" dropdownAlign={{ offset: [0, 0] }} popupClassName="custom-select-dropdown" />
            </Form.Item>
          </div>
          <div className="py-1 sm:col-span-2">
            {!isMobile && <p className="text-[#585F70] font-semibold mb-[2px]">Referral Code</p>}
            <Form.Item name="referralCode">
              <Input placeholder="Referral code" className="border border-slate-200 md:border-[#d9d9d9] rounded-[14px] md:rounded-lg w-full ps-3 md:ps-2 py-3 md:py-2" />
            </Form.Item>
          </div>
        </div>
        <div>
          <Form.Item name='conditions' valuePropName="checked" rules={[{ validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error('Please accept the terms and conditions.')), }]} >
            <Checkbox className='mt-3'>Yes, I agreed to the
              {/* <Link to={'/terms_&_conditions'} className='primary hover:underline duration-300' >Terms and conditions</Link> */}
              <a href="/assets/NEPTUNE-TNC.pdf" download='NeptuneT&C' className='ms-1 primary hover:underline duration-300' >Terms and Conditions</a>
            </Checkbox>
          </Form.Item>
        </div>
        <div className="mt-4">
          <LoadableButton type='submit' className={`${isMobile ? 'bg-primary-mobile py-3 rounded-[14px]' : 'bg-primary py-2'} text-[#FFFFFF] font-semibold text-lg rounded-lg w-full text`} lable='Open Account' isLoading={isLoading} />
        </div>
        <div className="text-center text-sm mt-4">
          <p>Already have an account? <Link to="/" className="primary underline">Sign In</Link></p>
        </div>
      </Form >
    </div >
  );
}
export default Register;